var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range-picker',{attrs:{"opens":"left","locale-data":{ firstDay: 1, format: 'DD.MM.YYYY' }},on:{"update":_vm.emitChange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})}
var staticRenderFns = []

export { render, staticRenderFns }